import { MarketplaceCartSchema } from "@redotech/redo-marketplace-common/marketplace-cart";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const removeFromCart = unaryRpc({
  name: "removeFromCart" as const,
  input: z.object({ productId: zExt.objectId(), variantId: zExt.objectId() }),
  output: z.object({ cart: MarketplaceCartSchema.nullable() }),
});
